export const configBucket = {
    bucketName: 'ecd-files',
    region: 'us-east-2',
    accessKeyId: 'AKIAYOEI6AJQXZAIPEJF',
    secretAccessKey: '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'
}